
const table = (items) => {
    if (items.data.content.length === 0) {
        return '';
    }
    let table_header = ''
    let table_body = ''
    // get the header of table
    items.data.content[0].forEach(head => {
        table_header += `<th>${head}</th>`
    })
    // get the body of table
    for(let i = 1; i < items.data.content.length; i++){
        table_body += `<tr>`
        items.data.content[i].forEach(body => {
            table_body += `<td>${body}</td>`
        })
        table_body += `</tr>`
    }

    return `
<div class="table-responsive-lg">
    <table class='table table-bordered table-striped'>
        <thead class='table-light'>
            <tr>
                ${table_header}
            <tr>
        </thead>
        <tbody>
            ${table_body}
        </tbody>
    </table>
</div>
    `;
}

module.exports = table
